<template>
  <article v-scroll:reveal class="layout-section -bg-image -align-center">
    <section class="layout-section__bg-image" style="background-image: url('/images/background.jpg');">
      <h4 v-scroll:reveal="{delay:75}" class="layout-section__title">{{ content.title }}</h4>
      <div v-scroll:reveal="{delay:150}" v-html="content.text" />
      
      <a 
        v-scroll:reveal="{delay:225}" 
        :href="content.link || 'https://mariedooley.com/collections/artwork'" 
        target="_blank" 
        class="button -light layout-section__cta"
      >
        {{ content.label }}
      </a>
    </section>
  </article>
</template>

<script>
export default {
  name: 'HomeCta',
  computed: {
    content() {
      return this.$i18n.t('cta')
    }
  }
}
</script>
